import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchBoardForEditor, fetchBoardOnly, saveBoard } from './actions';
import { ManagerSliceState } from './manager.slice';

export const createFetchBoardForEditorReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(fetchBoardForEditor.pending, (state) => {
    state.isLoading = true;
    state.isLoaded = false;
    state.error = null;
  });
  builder.addCase(fetchBoardForEditor.fulfilled, (state, action) => {
    state.activeTemplate = action.payload.template;
    state.activeBoard = action.payload.board as any;
    state.isLoading = false;
    state.isLoaded = true;
  });
  builder.addCase(fetchBoardForEditor.rejected, (state, action) => {
    state.isLoading = false;
    state.isLoaded = false;
    state.error = action.error.message ?? 'Failed to load board';
  });
};

export const createFetchBoardOnlyReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(fetchBoardOnly.pending, (state) => {
    state.isLoading = true;
    state.isLoaded = false;
    state.error = null;
  });
  builder.addCase(fetchBoardOnly.fulfilled, (state, action) => {
    state.activeTemplate = null;
    state.activeBoard = action.payload as any;
    state.isLoading = false;
    state.isLoaded = true;
  });
  builder.addCase(fetchBoardOnly.rejected, (state, action) => {
    state.isLoading = false;
    state.isLoaded = false;
    state.error = action.error.message ?? 'Failed to load board';
  });
};

export const createSaveBoardReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(saveBoard.pending, (state) => {
    state.isSaving = true;
    state.error = null;
  });
  builder.addCase(saveBoard.fulfilled, (state, action) => {
    state.isSaving = false;
    state.activeBoard = action.payload as any;
  });
  builder.addCase(saveBoard.rejected, (state, action) => {
    state.isSaving = false;
    state.error = action.error.message ?? 'Failed to save board';
  });
};
